/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type AnamnesisDtoAnamnesisType = (typeof AnamnesisDtoAnamnesisType)[keyof typeof AnamnesisDtoAnamnesisType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnamnesisDtoAnamnesisType = {
  MEDICAL: 'MEDICAL',
  SELF: 'SELF',
  EXTERNAL: 'EXTERNAL',
} as const;
